import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.overview.widget.avg.outputs');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

interface YearlyStat {
    year: number;
    papers: number;
    reports: number;
    patents: number;
    total: number;
}

@Component({
    selector: 'wiz-portal-overview-widget-avg-outputs',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.overview.widget.avg.outputs/view.scss */
/* src/app/portal.overview.widget.avg.outputs/view.scss: no such file or directory */`],
})
export class PortalOverviewWidgetAvgOutputsComponent implements OnInit {
    @Input() data!: ResearcherData;
    @Input() period: any;

    public researcher: any;
    public periodStart: number;
    public periodEnd: number;
    public products: any[];
    public filtered: any[] = [];

    public category: string = 'all';

    public categories = [
        { key: 'all', label: '전체', count: 0 },
        { key: 'paper', label: '논문', count: 0 },
        { key: 'patent', label: '특허', count: 0 },
        { key: 'report', label: '보고서', count: 0 },
    ];

    // 전체 합계
    summary: Array<{ key: string; label: string; count: number }> = [];

    // 연도별 데이터 (차트용)
    yearlyStats: YearlyStat[] = [];

    ngOnChanges(changes: SimpleChanges) {
        if (changes['period']) {
            const curr = changes['period'].currentValue;
            this.periodStart = curr?.start;
            this.periodEnd = curr?.end;
            this.updateStats();
        }
    }

    constructor(@Inject( Service)         public service: Service,    ) { }


    public async ngOnInit() {
        this.mapping();
    }

    public mapping() {
        this.researcher = this.data.researcher;
        this.periodEnd = this.period.end;
        this.periodStart = this.period.start;
        this.products = this.data.products;
        this.updateStats();
    }

    private updateStats(): void {
        if (!this.products?.length) {
            this.summary = [];
            this.yearlyStats = [];
            return;
        }

        // --- 기간 필터 ---
        const withinPeriod = this.products.filter(p => {
            const year = Number(p.pub_year);
            return year >= this.periodStart && year <= this.periodEnd;
        });

        // --- 카테고리별 카운트 (상단 버튼용) ---
        const papersCount = withinPeriod.filter(p => p.category === 'paper').length;
        const patentsCount = withinPeriod.filter(p => p.category === 'patent').length;
        const reportsCount = withinPeriod.filter(p => p.category === 'report').length;
        const totalCount = withinPeriod.length;

        this.categories = [
            { key: 'all', label: '전체', count: totalCount },
            { key: 'paper', label: '논문', count: papersCount },
            { key: 'patent', label: '특허', count: patentsCount },
            { key: 'report', label: '보고서', count: reportsCount },
        ];

        // --- 현재 카테고리에 따라 필터 ---
        this.filtered =
            this.category === 'all'
                ? withinPeriod
                : withinPeriod.filter(p => p.category === this.category);

        // --- 연도별 ---
        const yearly: YearlyStat[] = [];
        for (let y = this.periodStart; y <= this.periodEnd; y++) {
            const yearProducts = this.filtered.filter(
                p => Number(p.pub_year) === y
            ) ?? [];

            const papers = yearProducts.filter(p => p.category === 'paper').length;
            const patents = yearProducts.filter(p => p.category === 'patent').length;
            const reports = yearProducts.filter(p => p.category === 'report').length;
            const total = yearProducts.length;

            yearly.push({ year: y, papers, patents, reports, total });
        }
        this.yearlyStats = yearly;
        this.service.render();
    }

    public setCategory(key: string) {
        if (this.category === key) return; // 중복 클릭 방지
        this.category = key;
        this.updateStats();
    }

    trackByLabel = (_: number, s: { key: string; label: string }) => s.key || s.label;
}

export default PortalOverviewWidgetAvgOutputsComponent;